import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { ActionBadge } from '@modules/ide-provisioner/plugins-rules/common/action-badge/action-badge';
import { AutoInstallPreset } from '@modules/ide-provisioner/plugins-rules/common/auto-install-preset';
import { assignTestId } from '@common/infra/tests/assign-test-id';
import styles from './base-plugin-rule.css';
export function BasePluginRule({ rule, children, className }) {
    var _a;
    return (_jsxs("div", { className: classNames(styles.wrapper, className), ...assignTestId('plugin-rule'), children: [_jsx("div", { className: styles.content, children: children }), _jsx(ActionBadge, { action: rule.action, autoInstallPreset: rule.type === 'single-plugin' && ((_a = rule.singlePluginTypeRule) === null || _a === void 0 ? void 0 : _a.type) === 'bundled'
                    ? AutoInstallPreset.Enable
                    : AutoInstallPreset.AutoInstall })] }));
}
